export enum Role {
  Administrator,
  InternalUser,
  PromoUser,
  ExtenalUser,
}
